import { Unit } from "src/quantity";
import { Translations, UnitsLocale } from "./locale";
import { language } from "@codemirror/language";

export const translations = {
  select: "Select",
  selection: "Selection",
  junction: "Junction",
  pipe: "Pipe",
  reservoir: "Reservoir",
  hintPipeDrawStart: "Click to start the pipe, then click to add each vertex.",
  hintPipeDrawEnd: "End a pipe by double-clicking or hitting Enter.",
  keyboardShortcuts: "Keyboard Shortcuts",
  help: "Help",
  helpCenter: "Help Center",
  exit: "Exit",
  clearSelection: "Clear Selection",
  selectAll: "Select all",
  undo: "Undo",
  redo: "Redo",
  cheatsheet: "Cheatsheet",
  diameter: "Diameter",
  length: "Length",
  demand: "Demand",
  baseDemand: "Base Demand",
  actualDemand: "Actual Demand",
  elevation: "Elevation",
  roughness: "Roughness",
  minorLoss: "Loss Coeff.",
  property: "Property",
  properties: "Properties",
  value: "Value",
  values: "Values",
  status: "Status",
  open: "Open",
  closed: "Closed",
  "pipe.open": "Open",
  "pipe.closed": "Closed",
  "pump.on": "On",
  "pump.off": "Off",
  "pump.off.cannot-deliver-head": "Off - Cannot deliver head",
  "pump.on.cannot-deliver-flow": "On - Exceeds maximum flow",
  "valve.open.cannot-deliver-pressure": "Open - Cannot deliver pressure",
  "valve.open.cannot-deliver-flow": "Open - Cannot deliver flow",
  "valve.open": "Open",
  "valve.closed": "Closed",
  "valve.active": "Active",
  "valve.prv": "PRV",
  "valve.psv": "PSV",
  "valve.fcv": "FCV",
  "valve.pbv": "PBV",
  "valve.tcv": "TCV",
  "valve.prv.detailed": "PRV: Pressure Reducing Valve",
  "valve.psv.detailed": "PSV: Pressure Sustaining Valve",
  "valve.fcv.detailed": "FCV: Flow Control Valve",
  "valve.pbv.detailed": "PBV: Pressure Breaker Valve",
  "valve.tcv.detailed": "TCV: Throttle Control Valve",
  valveStatus: "Valve Status",
  initialStatus: "Initial Status",
  head: "Head",
  pumpType: "Pump Type",
  pumpHead: "Pump Head",
  cloudSimulate: "Cloud Simulate",
  simulate: "Simulate",
  simulation: "Simulation",
  simulationReport: "Simulation Report",
  simulationReadyToRun: "Ready to Run",
  simulationRunning: "Running...",
  simulationSuccess: "Simulation was Successful",
  simulationWarning: "Simulation with Warnings",
  simulationWarningExplain:
    "The simulation finished with one or more warnings. Review the simulation report for details.",
  simulationFailure: "Simulation with Errors",
  simulationFailureExplain:
    "Simulation run was unsuccessful. Review the simulation report for details.",
  simulationTook: "Simulation run took ${1}s.",
  simulationOutdated: "Simulation Outdated",
  runningSimulation: "Running Simulation...",
  notAvailable: "Not Available",
  pressure: "Pressure",
  pressures: "Pressures",
  flow: "Flow",
  flows: "Flows",
  velocity: "Velocity",
  velocities: "Velocities",
  asset: "Asset",
  assets: "Assets",
  none: "None",
  type: "Type",
  delete: "Delete",
  zoomTo: "Zoom To",
  min: "Min",
  max: "Max",
  mean: "Mean",
  sum: "Sum",
  openProject: "Open Project",
  opening: "Opening...",
  export: "Export",
  cancel: "Cancel",
  failedToOpenModel: "Failed to open model",
  failedToOpenModelDetail: "Make sure to provide a valid INP file.",
  understood: "Understood",
  error: "Error",
  save: "Save",
  saveAndContinue: "Save and Continue",
  saving: "Saving...",
  saved: "Saved",
  saveAs: "Save as...",
  saveCanceled: "Canceled saving",
  menubarFile: "File",
  // 在现有翻译中添加
  workspace: "Workspace",
  openWorkspace: "Open Workspace",
  projectName: "Project Name",
  // 在翻译文件中添加
  projects: "Projects",
  tasks: "Tasks",
  teams: "Teams",
  settings: "Settings",
  //comingSoon: "Coming Soon",
  // 在翻译文件中添加
  publicProjects: "Public Projects",
  hydroArk:"Hydro-Ark",
  browsePublicProjects: "Browse Public Projects",
  unsavedChanges: "Unsaved Changes",
  unsavedChangesQuestion:
    "Do you want to save the changes made to the current project?",
  discardChanges: "Discard Changes",
  shortcuts: "Shortcuts",
  onboardingViewAndEdit: "View and edit properties",
  onboardingSelectDrawing: "Select a drawing tool from the menu${1}",
  onboardingDrawReservoir: "Click anywhere to place a reservoir.",
  onboardingDrawJunctions: "Click to place junctions.",
  onboardingStartPipe:
    "Click on an existing node to draw a pipe, or click anywhere to start with a new junction.",
  onboardingStartPipeEmpty: "Click anywhere to start drawing a pipe.",
  onboardingCtrlPipe:
    "Hold ${1} and click to end and start a new pipe immediately.",
  onboardingDrawPipe:
    "Click to define vertices. Finish at a junction or double-click to add one.",
  onboardingStartPump:
    "Click on an existing node to draw a pump, or click anywhere to start with a new junction.",
  onboardingStartPumpEmpty: "Click anywhere to start drawing a pump.",
  onboardingCtrlPump:
    "Hold ${1} and click to end and start a new pump immediately.",
  onboardingDrawPump:
    "Click to define vertices. Finish at a junction or double-click to add one.",
  onboardingStartValve:
    "Click on an existing node to draw a valve, or click anywhere to start with a new junction.",
  onboardingStartValveEmpty: "Click anywhere to start drawing a valve.",
  onboardingCtrlValve:
    "Hold ${1} and click to end and start a new valve immediately.",
  onboardingDrawValve:
    "Click to define vertices. Finish at a junction or double-click to add one.",
  onboardingSelectAsset: "Select any asset to view and modify its properties.",
  onboardingRunningModel: "Running a model and viewing results",
  onboardingRunSimulation:
    "Press Simulate button to run a hydraulic simulation.",
  onboardingMap:
    "Switch to the Map tab to add visualizations of hydraulic results.",
  onboardingOtherFeatures: "Other helpful features",
  onboardingUndoRedo: "Undo or redo with ${1} and ${2}.",
  onboardingFiles: "Working with files",
  onboardingMoveNode: "Drag the node to change its position.",
  onboardingAutomaticCalculations:
    "Elevations and lengths are assigned automatically.",
  onboardingAutomaticUpdates:
    "Elevations and lengths are updated automatically.",
  onboardingAutomaticElevations: "Elevations are assigned automatically.",
  onboardingAutomaticLengths: "Length is calculated automatically.",
  unitsSystem: "Units System",
  units: "Units",
  usCustomaryFlowsExpressed: "US Customary with flows expressed in ${1}",
  siFlowsExpressed: "International System with flows expressed in ${1}",
  newProject: "New Project",
  create: "Create",
  createNew: "Create New",
  creating:"Creating...",
  importInp: "Import INP",
  importInpToProject: "Import INP",
  selectInpFile: "Choose File",
  dropInp: "Drop an .INP file here to open the model.",
  inpMissing: "Invalid file type. Use an .INP file.",
  onlyOneInp: "Multiple INPs",
  onlyOneInpExplain:
    "Only one INP file is allowed at a time.\nThe first one will be used.",

  "cloudSave.loginRequired": "Please log in first",
  "cloudSave.loginRequiredDescription": "Cloud saving requires user authentication",
  "cloudSave.projectRequired": "Please open a project first",
  "cloudSave.projectRequiredDescription": "You need to open a project before saving to cloud",
  "cloudSave.saveSuccess": "Project saved to cloud",
  "cloudSave.updateSuccess": "Project updated to cloud",
  "cloudSave.saveFailed": "Save failed",
  "cloudSave.saveFailedDescription": "An error occurred while saving to cloud",
  "cloudSave.branch1Update": "Updating existing cloud project",
  "cloudSave.branch2Upload": "Saving local project to cloud",
  "cloudSave.branch3Create": "Creating new project and saving to cloud",

  "auth.loginRequiredForExport": "Please log in first",
  "auth.loginRequiredForExportDescription": "You need to log in to export INP files",

  headlossFormula: "Headloss Formula",
  headlossShort: "Headloss",
  headloss: "Headloss",
  autoLengths: "Auto-Lengths",
  autoElevations: "Auto-Elevations",
  on: "On",
  viewReport: "View Report",
  ignore: "Ignore",
  loading: "Loading...",
  ok: "OK",
  toggleSatellite: "Toggle satellite basemap",
  welcomePage: "Welcome Page",
  welcomeToEpanetJs: "Welcome to 百川清云 • QWater!",
  welcomeIntro:
    "We're creating a new way to build and run hydraulic models—right from your browser in a modern, web-based, EPANET platform. Quickly open, edit, and analyze your networks on your computer without installing any software. All simulations run directly on your machine, keeping your data private—no cloud required.",
  welcomeNewHere:
    "New here? Check out our ${1} to learn the basics in just a few minutes!",
  welcomeExploreWithSamples: "Explore the app by opening a sample network",
  welcomeBuildAndDevelop: "Build and Develop",
  quickStartTutorial: "Quick Start Guide",
  gettingStarted: "Getting Started",
  demoUKStyleDescription: "UK style network with metric units and flow in l/s.",
  demoUSStyleDescription:
    "North American style network with US units and flow in GPM.",
  alwaysShowAtStart: "Always show at start up",
  termsAndConditions: "Terms and Conditions",
  privacyPolicy: "Privacy Policy",
  downloadFailed: "Download Failed",
  checkConnectionAndTry: "Please check your internet connection and try again.",
  geocodingNotSupported: "Geocoding not supported",
  geocodingNotSupportedDetail:
    "Your INP includes coordinates or vertices that use a projection system that is not supported yet. Please ensure all assets are geocoded using the WGS84 standard.",
  missingCoordinates: "Coordinates Missing",
  missingCoordinatesDetail:
    "Your INP is missing required coordinates. Please ensure all assets include geocoded information using the WGS84 standard.",
  inpNotFullySupported: "Your INP is not fully supported",
  inpNotFullySupportedDetail:
    "Some features of your INP file are not fully supported yet, which could affect the results.",
  newFeaturesEveryDay:
    "We're continuously adding new features and improvements! Stay informed about the latest updates by subscribing to our newsletter!",
  subscribeForUpdates: "Subscribe for Updates",
  seeDemoNetworks: "See Demo Networks",
  issuesSummary: "Issues Summary",
  useOfUnsupported: "Use of unsupported sections",
  nonDefaultEpanetValues: "Non-default epanet ${1} values detected",
  customValueNotSupport: "Custom ${1} not supported (using ${2})",
  ignoredValuesDetected: "Ignored ${1} values detected",
  valueIgnored: "${1} value is ignored (using ${2})",
  nodesMissingCoordinates: "Nodes missing coordinates",
  andXMore: "and ${1} more...",
  alertInpOutput: "Some data may be lost",
  alertInpOutputSubtitle: "Your INP file was created with another application.",
  alertInpOutputDetail:
    "Please note that some sections and settings may be formatted differently or omitted. We encourage you to save a copy instead of overriding the original content.",
  label: "Label",
  login: "Log In",
  register: "Register",
  openSource: "Open Source",
  nodes: "Nodes",
  node: "Node",
  links: "Links",
  link: "Link",
  layers: "Layers",
  checkoutProjectionTool:
    "You can project your INP to the WGS84 system making use of the EPANET Projection Converter utility.",
  signUpToUnlockResolution:
    "Register to unlock high resolution satellite images.",
  continueWithLowResolution: "Continue with low resolution",
  oopsSomethingWrong: "Oops! Something went wrong.",
  errorProcessingRequest: "An unexpected error has occurred.",
  pleaseTryAgain: "Please try again, and if the issue persists, email us at",
  reloadPage: "Reload Page",
  addCustom: "Add Custom",
  chooseType: "Choose Type",
  toggleVisibility: "Toggle Visibility",
  toggleLabelsVisibility: "Toggle Labels Visibility",
  basemap: "Basemap",
  back: "Back",
  updateLayer: "Update Layer",
  addLayer: "Add Layer",
  name: "Name",
  xyzURLContain: "XYZ URL should contain {z}, {x} and {Y}.",
  supports: "Supports",
  checkMapboxDocs: "See Mapbox documentation on",
  here: "here",
  accessToken: "Access Token",
  upgradeYourAccount: "Upgrade your account",
  upgrade: "Upgrade",
  planExplain: "${1} plan",
  "plan.pro": "Professional",
  "plan.free": "Free",
  "plan.education": "Education",
  "plan.personal": "Personal",
  for: "For",
  commercialUse: "Commercial Use",
  nonCommercialUse: "Non-commercial Use",
  monthly: "Monthly",
  yearlyWithDiscount: "Yearly - save up to ${1}%",
  studentOrPersonal: "Student or personal use? Switch here!",
  "free.forBetterModelling": "For a better modeling experience",
  "free.webBasedEpanet": "Web-based EPANET model",
  "free.backgroundMap": "Background maps and satellite",
  "free.elevations": "Automated elevations",
  "free.noLimits": "No limits on sizes",
  "free.communitySupport": "Community support",
  currentPlan: "Current Plan",
  everythingAnd: "Everything in ${1}, and",
  everythingInForFree: "Everything in ${1} for free!",
  professionalSupport: "Professional support",
  customMapLayers: "Custom map layers",
  scenarios: "Scenarios",
  cloudStorage: "Cloud storage",
  pointInTimeRestore: "Point in time restore - ${1} days",
  demandsAnalysis: "Demands analysis",
  liveDataCompare: "Live data comparision",
  monthShort: "mo",
  year: "year",
  upgradeTo: "Upgrade to ${1}",
  comingSoon: "Coming Soon",
  individualNamedLicense: "Individual named license",
  floatingSharedLicenses: "Floating shared licenses",
  mostPopular: "Most popular",
  minimumTwoLicenses: "Minimum 2 licenses",
  teamStorage: "Team storage",
  prioritySupport: "Priority support",
  sharingModels: "Sharing models",
  volumeDiscounts: "Volume discounts",
  tryItYourself: "Try it out yourself",
  learnWithEpanetJS: "Learn with epanet-js",
  learnMore: "Learn more.",
  useStudentEmail: "Use Student Email",
  layerAdded: "Layer added",
  addingLayer: "Adding layer...",
  layerUpdated: "Layer updated",
  updatingLayer: "Updating layer...",
  havingIssuesWithStudentEmail: "Having issues validating your email?",
  getHelp: "Get Help",
  startNode: "Start Node",
  endNode: "End Node",
  pump: "Pump",
  designHead: "Design Head",
  designFlow: "Design Flow",
  power: "Power",
  definitionType: "Definition Type",
  constantPower: "Constant Power",
  flowVsHead: "Flow vs Head",
  speed: "Speed",
  pumpStatus: "Pump Status",
  valve: "Valve",
  setting: "Setting",
  valveType: "Valve Type",
  fixedStatus: "Fixed Status",
  rampShouldBeAscending: "Ramp input values need to be in ascending order.",
  notEnoughData: "Not enough data.",
  updated: "Updated",
  unableToUpdate: "Cannot Update",
  invalidRange: "Invalid Range",
  fixRangeToApply: "Please adjust the range to apply changes.",
  flowAbs: "Flow (Abs.)",
  regenerate: "Regenerate",
  mode: "Mode",
  classes: "Classes",
  colorRamp: "Color Ramp",
  continuousRamp: "Continuous",
  divergingRamp: "Diverging",
  reverseColors: "Reverse Colors",
  addBreak: "Add Break",
  equalIntervals: "Equal Intervals",
  equalQuantiles: "Equal Quantiles",
  manual: "Manual",
  prettyBreaks: "Pretty Breaks",
  naturalBreaksCkMeans: "Natural Breaks (ckmeans)",
  unitHeadloss: "Unit Headloss",
  showLabels: "Show Labels",
  map: "Map",
  colorBy: "Color by",
  range: "Range",
  ramp: "Ramp",
  labels: "Labels",
  nodeSymbology: "Node Symbology",
  linkSymbology: "Link Symbology",
  ckmeans: "Ckmeans",
  simulationSettings: "Simulation Settings",
  demandMultiplier: "Demand Multiplier",
  saveAndRun: "Save & Run",
  failedToFetchElevation: "Failed to Fetch Elevation",
  failedToFetchElevationExplain:
    "Elevation data cannot be retrieved, so 0 will be assigned.",
  elevationNotAvailable: "Elevation Not Avaiable",
  elevationNotAvailableExplain:
    "It wasn't possible to retrieve the elevation for this point. Using 0 instead.",
  noInternet: "No Internet Connection",
  noInternetExplain: "Some features may not be available.",
  connectionRestored: "Connection Restored!",
  mapOfflineMode: "Map Offline Mode",
  mapOfflineModeExplain: "The application is now using a blank background.",
  failedToLoad: "Failed To Load",
  failedToLoadTileJSON:
    "A TileJSON layer failed to load. The tile server may be down",
  headsUpSmallScreen: "Heads Up! Not Optimized for Small Screens",
  smallScreenExplain:
    "It looks like you're trying to access the app from a smaller device. This application is currently in preview mode for this screen size, and some editing features may not be available.",
  hereYourOptions: "Here are your options",
  continueAnyway: "Continue Anyway",
  continueAnywayExplain:
    "You can proceed, but the experience may not be ideal, and some features might be missing.",
  watchQuickDemo: "Watch a Quick Demo",
  watchQuickDemoExplain:
    "View a short demonstration showing the full app experience on desktop.",
  visitLandingPage: "Visit Our Landing Page",
  visitLandingPageExplain: "Learn more about the app and what it can do.",
  file: "File",
  somethingWentWrong: "Something Went Wrong",
  tryAgainOrSupport:
    "Please try again, and if the error persists, contact support.",
  planChangesFromSupport: "Plan changes require support",
  planChangesFromSupportExplain:
    "Please contact our support team to modify your subscription.",
  upgradeSuccessful: "Upgrade Successful!",
  upgradeSuccessfulExplain:
    "Thanks for upgrading — your new features are now unlocked.",
  // hoursAgo: "${1} hours ago",
  // daysAgo: "${1} days ago",
  // justNow: "Just now",

  // 工作空间相关
  allProjects: "All Projects",
  myProjects: "My Projects",
  teamProjects: "Team Projects",
  favorites: "Favorites",
  searchProjects: "Search Projects...",
  // projectName: "Project Name",
  lastModified: "Last Modified",
  views: "Views",
  actions: "Actions",
  team: "Team",
  personal: "Personal",
  createProject: "Create Project",
  projectsFound: "Found ${1} Projects",
  compressionRatio: "Compression Ratio",
  unknown: "Unknown",
  // openProject: "Open Project",
  // delete: "Delete",
  // error: "Error",
  // reloadPage: "Reload Page",
  noProjectsFound: "No Projects Found",
  justNow: "Just Now",
  minutesAgo: "${1} Minutes Ago",
  hoursAgo: "${1} Hours Ago",
  daysAgo: "${1} Days Ago",
  weeksAgo: "${1} Weeks Ago",        // 添加这行
  monthsAgo: "${1} Months Ago",      // 添加这行
  invalidDate: "Invalid Date",       // 添加这行
  private: "Private",
  public: "Public",
  copies: "Copies",
  // projects: "Projects",
  // tasks: "Tasks",
  // teams: "Teams",
  // settings: "Settings",
  // type: "Type"

  // lastModified: "Last Modified",
  // name: "Name",
  dateCreated: "Date Created",
  viewCount: "View Count",

  noProjectsYet: "No projects yet",
  createFirstProject: "Create your first water network project to get started",
  // createProject: "Create Project",

  language: "Language",
  saveToCloud: "Save (@)",

  // 水流播放动画
  flowAnimation: "Flow Animation",
  flowAnimationTooltip: "Toggle water flow animation",
  playAnimation: "Play Animation",
  pauseAnimation: "Pause Animation",
  animationSpeed: "Animation Speed",
  flowSpeedHigh: "High Flow Speed",
  flowSpeedMedium: "Medium Flow Speed",
  flowSpeedLow: "Low Flow Speed",

  // 资产面板
  enterFullscreen: "Enter Fullscreen",
  exitFullscreen: "Exit Fullscreen",
  expandPanel: "Expand Panel",
  collapsePanel: "Collapse Panel",
  closePanel: "Close Panel",

  // 文件操作
  fileOperations: "Create New or Import INP",
  loadFromLocal: "Load from Local",
  loadFromExamples: "Load from Examples",
  dragDropInpFile: "Drag & Drop EPANET's INP File Here",
  orBrowseFiles: "Or Browse Files",
  clientSideNotice: " *QingChuan·QWater* is a client-side application. No server backend is used. All data is stored on your computer/browser. No information or map data is sent to any server.",
  noDataQuestion: "No Data?",
  trySampleData: "Try Sample Data",

};

export const units: Record<Exclude<Unit, null>, string> = {
// export const units: UnitsLocale = {
    m: "m",
    mm: "mm",
    in: "in",
    ft: "ft",
    "l/s": "l/s",
    "l/h": "l/h",
    km: "km",
    "gal/min": "gal/min",
    psi: "psi",
    mwc: "m",
    "m/s": "m/s",
    "m^3": "m³",
    "ft^3": "ft³",
    "ft/s": "ft/s",
    "ft^3/s": "ft³/s",
    "l/min": "l/min",
    "Mgal/d": "Mgal/d",
    "IMgal/d": "IMgal/d",
    "Ml/d": "Ml/d",
    "m^3/h": "m³/h",
    "m^3/d": "m³/d",
    "acft/d": "acft/d",
    hp: "hp",
    kW: "kW",
    "m/km": "m/km",
    "ft/kft": "ft/kft"
};
